<template>
  <div class="user-profile">
    <SearchArea />
    <div class="main-container lg:flex">
      <ul class="lg:w-1/4 font-medium lg:pr-7.5 text-lg">
        <li class="pb-2.5">
          <router-link
            class="profile-links"
            :class="routeName == 'My Account' ? 'bg-blue text-white' : 'bg-smoke-100'"
            :to="{name: 'My Account'}"
          >
            <i class="w-6 icon-account"></i>
            <span class="pl-3 leading-8">Account Settings</span>
          </router-link> 
        </li>
        <li class="pb-2.5">
          <router-link
            class="profile-links"
            :class="routeName == 'My Addresses' ? 'bg-blue text-white' : 'bg-smoke-100'"
            :to="{name: 'My Addresses'}"
          >
            <i class="w-6 icon-address"></i>
            <span class="pl-3 leading-8">My Addresses</span>
          </router-link>
        </li>
        <li class="pb-2.5">
          <router-link
            class="profile-links"
            :class="routeName == 'Payment Methods' ? 'bg-blue text-white' : 'bg-smoke-100'"
            :to="{name: 'Payment Methods'}"
          >
            <i class="w-6 icon-payment"></i>
            <span class="pl-3 leading-8">Payment Methods</span>
          </router-link>
        </li>
        <li :class="{'pb-2.5': !isOrderRoutes}">
          <router-link
            class="profile-links"
            :class="isOrderRoutes ? 'bg-blue text-white' : 'bg-smoke-100'"
            :to="{name: 'My Orders'}"
          >
            <i class="w-6 icon-checklist"></i>
            <span class="pl-3 leading-8">My Orders</span>
          </router-link>
        </li>
        <li v-if="isOrderRoutes" class="pb-2.5">
          <router-link
            class="flex items-center py-2 pr-5 rounded-lg pl-14 bg-smoke-100"
            :class="{'text-blue': routeName === 'My Draft'}"
            :to="{name: 'My Draft'}"
          >
            <DraftIcon />
            <span class="pl-3 leading-8">My Draft Orders
              <span v-if="getTotalDraftsCount !== null">({{ getTotalDraftsCount }})</span>
            </span>
          </router-link>
        </li>
        <li class="pb-2.5">
          <router-link
            class="profile-links"
            :class="routeName == 'Change Password' ? 'bg-blue text-white' : 'bg-smoke-100'"
            :to="{name: 'Change Password'}"
          >
            <i class="w-6 icon-lock"></i>
            <span class="pl-3 leading-8">Change Password</span>
          </router-link>
        </li>
        <li class="profile-links bg-smoke-100 cursor-pointer" @click="signOut">
          <i class="w-6 icon-exit"></i>
          <span class="pl-3 leading-8">Logout</span>
        </li>
      </ul>
      <div class="lg:w-3/4 lg:pl-2.5 mt-4 lg:mt-0 pb-30">
        <div class="rounded-lg bg-smoke-100 p-5 md:py-7.5 md:px-12">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SearchArea from '@/shared/components/layout/SearchArea'
import DraftIcon from '@/shared/components/profile/order/DraftIcon'
import store from '@/store/index'

export default {
  name: 'Profile',
  components: {
    SearchArea,
    DraftIcon
  },
  created() {
  //  let is_user_loggedin = ;
    if (!store.getters.isUserLoggedIn) { 
      localStorage.setItem('previousUrl',window.location)
      this.$router.push({name: 'LoginSelection'})
    } else {
      this.countTotalDrafts()
    }
  },
  computed: {
    ...mapGetters (['getTotalDraftsCount']),
    routeName() {
      return this.$route.name
    },
    isOrderRoutes() {
      return ['My Orders', 'My Draft' , 'Sourcing Order Info'].includes(this.routeName) ? true : false
    },
  },
  methods: {
    ...mapActions ([
      'logout',
      'resetUserCart',
      'fetchDraftOrders',
      'changeTotalDraftsCount'
    ]),
    async countTotalDrafts() {
      let draftOrders = await this.fetchDraftOrders('data')
      if (draftOrders.result) this.changeTotalDraftsCount(draftOrders.total_results)
      else this.changeTotalDraftsCount(null)
    },
    async signOut() {
      await this.logout()
      this.resetUserCart()
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>
<style lang="scss" scoped>
  .user-profile {
    .profile-links {
      @apply flex items-center py-2 px-5 rounded-lg
    }
  }
</style>